<template>
  <div class="container">
    <p class="title">RANKING</p>
    <div class="wrap">
      <div class="ward">
        <ul class="section">
          <li v-for="i in 5" :key="i">{{ i }}</li>
        </ul>
        <ul class="total">
          <li
            v-for="(item, index) in shoesOutward"
            :key="index"
          ><CounterComponent :count="Number(item)"/></li>
        </ul>
      </div>
      <div class="icon">
        <img src="@/assets/img/crown.svg" alt>
      </div>
      <div class="ward">
        <ul class="section">
          <li v-for="i in 5" :key="i">{{ i + 5 }}</li>
        </ul>
        <ul class="total">
          <li
            v-for="(item, index) in shoesReturnTrip"
            :key="index"
          ><CounterComponent :count="Number(item)"/></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import CounterComponent from "@/components/Counter.vue";

export default {
  name: "ResultHeaderComponent",
  components: {
    CounterComponent
  },
  computed: {
    shoesOutward() {
      let temp = _.values(this.$store.state.shoes);
      return temp.slice(0, 5);
    },
    shoesReturnTrip() {
      let temp = _.values(this.$store.state.shoes);
      return temp.slice(5);
    }
  }
};
</script>

<style scoped lang="scss">
$space: 0.78em;
$width: vw(42);
.container {
  position: relative;
  padding: vw(30) vw(10) vw(10);
  background-color: $bg-color;
  line-height: 1;
}
.title {
  font-size: vw(36);
  margin-bottom: 0.42em;
}
.icon {
  margin-top: auto;
  margin-bottom: vw(15);
}
.wrap {
  position: relative;
  display: flex;
  justify-content: space-between;
}
.section {
  display: flex;
  justify-content: space-around;
  font-size: vw(24);
  height: $space;
  margin-bottom: 0.83em;
  > li {
    width: $width;
  }
}
.total {
  display: flex;
  justify-content: space-around;
  font-size: vw(24);
  margin-bottom: 0.42em;
  > li {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: $width;
    &::after {
      content: "23";
      display: inline-block;
      font-size: 0.5em;
      height: $space;
      padding: 0.4em 0.2em;
      border-top: 1px solid $text-color;
    }
  }
}
@media #{$mq-md} {
  $width: vw(64, 1600);
  .container {
    padding: vw(30, 1600) vw(10, 1600) vw(20, 1600);
  }
  .title {
    font-size: vw(64, 1600);
  }
  .icon {
    width: vw(60, 1600);
    margin-top: vw(70, 1600);
    margin-bottom: auto;
    > img {
      max-width: initial;
      width: 80%;
    }
  }
  .wrap {
    justify-content: center;
  }
  .section {
    font-size: vw(38, 1600);
    > li {
      width: $width;
    }
  }
  .total {
    font-size: vw(38, 1600);
    > li {
      width: $width;
    }
  }
}
</style>
